import { Tag } from "@arco-design/web-react";

import { formatFeeAdjustmentCompactAmount, getMemberFeeAdjustmentAmounts } from "../service";
import type { FeeAdjustmentRecord } from "../types";
import "./feeAdjustmentMemberTable.css";

/** 公共详情与成员详情共用个人金额口径，冻结基准、原加价与取整结果分别展示。 */
export function FeeAdjustmentMemberTable({ record, label, currentMemberId }: {
  record: FeeAdjustmentRecord;
  label: string;
  currentMemberId?: string;
}) {
  const processed = record.status === "processed";
  return <div className="fee-adjustment-member-table-wrap"><table className="fee-adjustment-member-table" aria-label={label}>
    <thead><tr>{["成员", "人员类型", "是否出钱", "基准应收", "成本变化", "加价金额", "取整金额", "应收变化"].map((title) => <th key={title}>{title}</th>)}</tr></thead>
    <tbody>{record.members.map((member) => {
      const amounts = processed ? getMemberFeeAdjustmentAmounts(record, member) : null;
      const current = member.roster_member_id === currentMemberId;
      return <tr key={member.roster_member_id} className={current ? "is-current-member" : undefined}>
        <td>{member.member_name_snapshot}{current ? "（当前成员）" : ""}</td>
        <td>{member.traveler_type_snapshot}</td>
        <td><Tag color={member.is_payer ? "blue" : "gray"}>{member.is_payer ? "出钱" : "不出钱"}</Tag></td>
        <td>{formatFeeAdjustmentCompactAmount(member.base_receivable_amount, false)}</td>
        {[member.cost_allocation_amount, member.sales_amount, amounts?.integerMarkupAmount, amounts?.receivableDeltaAmount].map((value, index) => {
          const text = processed ? formatFeeAdjustmentCompactAmount(value, true) : "待处理";
          const direction = text.startsWith("+") ? "increase" : text.startsWith("−") ? "decrease" : "same";
          return <td key={index} data-direction={direction}>{text}</td>;
        })}
      </tr>;
    })}</tbody>
  </table></div>;
}
